import { useQuery, type ApolloQueryResult } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { getBalances, getAdsBalance } from './useBusinessBalance.helpers';
import { useCurrentUser } from '@/features/Profile/core/hooks/useCurrentUser';
import {
  GET_BALANCE,
  BalanceResponse,
} from '@/features/Profile/sections/Balance/api';
import type { BalanceItem } from '@/features/Profile/sections/Balance/api';

type UseBusinessBalanceReturn = {
  balances: BalanceItem[];
  adsBalance: BalanceItem;
  loading: boolean;
  refetchBalance: () => Promise<ApolloQueryResult<BalanceResponse>>;
};

export function useBusinessBalance(): UseBusinessBalanceReturn {
  const { t } = useTranslation();
  const { isShop, loading: isUserLoading } = useCurrentUser();

  const isBrowser = typeof window !== 'undefined';

  const {
    data,
    loading: isBalanceLoading,
    refetch: refetchBalance,
  } = useQuery<BalanceResponse>(GET_BALANCE, {
    skip: !isBrowser || !isShop,
    fetchPolicy: 'cache-and-network',
  });

  const balance = data?.currentUserBalance;

  return {
    balances: getBalances(balance, t),
    adsBalance: getAdsBalance(balance?.paidAds, t),
    loading: isUserLoading || isBalanceLoading,
    refetchBalance,
  };
}
